import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitoimagicacab() {



const cardData = {
  keyword: " Mumbai to Imagica Cab",

headingDescription:
  "Omshree Cab provides reliable and comfortable Mumbai to Imagica cab services for travelers looking to enjoy a fun-filled day at one of India’s most popular theme parks. Whether you are planning a family outing, weekend getaway, group adventure, or a day trip with friends, our cab service ensures a safe, smooth, and hassle-free journey from Mumbai. We offer flexible booking options including one-way, round-trip, and multi-day plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in highway and city driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Imagica cab services.",

topPlaces: [
  {
    title: "Imagica Theme Park",
    description:
      "Imagica Theme Park is a premier amusement park near Mumbai, offering thrilling rides, live entertainment, and family-friendly attractions. Visitors can enjoy roller coasters, water rides, and themed zones designed for both kids and adults. Traveling by cab ensures a comfortable and timely journey, allowing guests to maximize their day at the park without worrying about local transport or parking."
  },
  {
    title: "Water Kingdom",
    description:
      "Water Kingdom, adjacent to Imagica, is India’s largest water park featuring slides, wave pools, and splash zones. Visitors can enjoy a full day of water fun, adventure, and relaxation. A cab ride provides hassle-free access, enabling families and friends to plan their visit efficiently and spend more time enjoying the attractions."
  },
  {
    title: "Snow Park",
    description:
      "Imagica’s Snow Park offers a unique winter wonderland experience with snow slides, snowball fights, and ice activities. Visitors can enjoy a cool retreat from the heat, photography, and themed experiences. Traveling by cab ensures safe and convenient access, allowing guests to enjoy all entertainment zones seamlessly."
  },
  {
    title: "Adventure Rides",
    description:
      "Imagica features adrenaline-pumping adventure rides like roller coasters, drop towers, and simulators. Visitors seeking thrills can enjoy these attractions safely under park supervision. A cab service ensures timely arrival from Mumbai, giving travelers ample time to experience multiple rides in one visit."
  },
  {
    title: "Restaurants & Food Courts",
    description:
      "Imagica and Water Kingdom have multiple restaurants, cafes, and food courts offering a variety of cuisines, snacks, and beverages. Visitors can take breaks, enjoy meals, and plan their day comfortably. Traveling by cab provides the flexibility to manage time efficiently between rides, shows, and dining."
  },
  {
    title: "Gift Shops & Souvenirs",
    description:
      "The park has several gift shops where visitors can purchase souvenirs, merchandise, and memorabilia to remember their visit. A cab ride from Mumbai ensures hassle-free transport, allowing tourists to combine shopping with entertainment without worrying about carrying items during travel."
  },
  {
    title: "Live Shows & Entertainment",
    description:
      "Imagica offers daily live performances, parades, and themed entertainment shows for all age groups. Visitors can enjoy interactive shows, character meets, and cultural programs. Traveling by cab ensures safe and comfortable transport, allowing visitors to arrive fresh and ready for a full day of entertainment."
  },
  {
    title: "Night Rides & Illuminations",
    description:
      "The park comes alive in the evening with illuminated rides and special night attractions. Visitors can enjoy a magical atmosphere, photography, and evening entertainment. A cab service ensures convenient return travel to Mumbai after enjoying the full park experience."
  },
  {
    title: "Nearby Resorts & Stay Options",
    description:
      "For travelers planning multi-day visits, Imagica has nearby resorts and hotels offering comfortable stays, themed experiences, and dining options. A cab ride provides seamless transport from Mumbai, making it easier to plan overnight stays and extended park visits."
  },
  {
    title: "Adventure & Fun Zones for Kids",
    description:
      "Imagica has dedicated play zones and attractions for younger children, ensuring safe and enjoyable experiences. Visitors can relax while kids enjoy interactive rides and fun activities. Traveling by cab ensures timely arrival and comfortable travel for families visiting from Mumbai."
  }
],




services: [
{
name: "Mumbai to Imagica Cab",
description: "Mumbai to Imagica cab service offers comfortable and reliable travel for visitors planning a fun trip to Imagica Theme Park near Khopoli. Our fleet includes AC sedans, SUVs, and premium vehicles designed for smooth highway travel via the Mumbai–Pune Expressway. Professional drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, and Mumbai airport terminals. Ideal for families, friends, and corporate outings visiting Imagica. Spacious seating and air-conditioned interiors ensure relaxed travel throughout the journey. Flexible one-way and round-trip options allow convenient travel planning. Transparent pricing ensures a smooth and stress-free cab booking experience."
},
{
name: "Mumbai to Imagica Taxi",
description: "Mumbai to Imagica taxi service provides dependable transportation for travelers heading to the popular Imagica amusement park. Comfortable AC vehicles ensure pleasant travel across the highway route connecting Mumbai and Khopoli. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for families, tourists, and weekend travelers. Clean interiors and spacious seating provide a comfortable journey. Flexible departure schedules allow passengers to plan trips conveniently. Reliable taxi services ensure safe and smooth travel."
},
{
name: "Mumbai to Imagica Cab Service",
description: "Mumbai to Imagica cab service offers reliable transportation for visitors traveling to the famous Imagica Theme Park. Our well-maintained AC vehicles ensure smooth highway journeys and comfortable seating. Professional drivers ensure safe driving and punctual pickup services. Pickup is available from residential areas, offices, hotels, and airport terminals across Mumbai. Ideal for family trips, tourism visits, and corporate outings. Spacious interiors ensure relaxed seating for passengers. Flexible booking options allow travelers to schedule rides easily. Transparent pricing ensures dependable cab service."
},
{
name: "Mumbai to Imagica Taxi Service",
description: "Mumbai to Imagica taxi service offers convenient and comfortable road travel for passengers visiting Imagica amusement park. Our fleet includes AC sedans and SUVs suitable for short highway journeys. Skilled drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourists, families, and weekend travelers. Spacious seating ensures comfort throughout the journey. Flexible travel schedules allow convenient trip planning. Affordable fares ensure smooth taxi travel."
},
{
name: "Cab from Mumbai to Imagica",
description: "Cab from Mumbai to Imagica provides private and comfortable transportation for travelers planning a fun-filled theme park visit. AC vehicles ensure smooth highway travel along the Mumbai–Pune Expressway route. Professional drivers ensure safe driving and reliable service during the journey. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for families, tourists, and corporate groups. Spacious interiors ensure comfortable seating for passengers. Flexible departure timing allows convenient travel planning. Reliable cab services ensure stress-free travel."
},
{
name: "Taxi from Mumbai to Imagica",
description: "Taxi from Mumbai to Imagica provides dependable road transportation for travelers visiting the popular entertainment destination near Khopoli. Comfortable AC vehicles ensure pleasant travel conditions throughout the journey. Experienced drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for families, couples, and tourism travel. Clean interiors and spacious seating ensure passenger comfort. Flexible scheduling options allow easy trip planning. Professional taxi services ensure reliable intercity travel."
},
{
name: "Mumbai to Imagica Cab Booking",
description: "Mumbai to Imagica cab booking allows passengers to reserve vehicles easily for theme park travel. Online and phone booking options provide instant confirmation and convenient scheduling. Comfortable AC sedans and SUVs ensure smooth highway journeys. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourism travel, family outings, and group trips. Flexible one-way and round-trip booking options are available. Reliable booking services ensure hassle-free travel planning."
},
{
name: "Mumbai to Imagica Taxi Booking Online",
description: "Mumbai to Imagica taxi booking online provides quick and convenient reservations for travelers planning a theme park visit. Instant booking confirmation helps travelers schedule rides easily. Comfortable AC vehicles ensure relaxed travel conditions throughout the journey. Experienced drivers ensure safe and professional driving services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for families, tourists, and corporate outings. Flexible travel timing allows convenient trip scheduling. Reliable booking systems ensure smooth taxi reservations."
},
{
name: "Mumbai to Imagica Cab Price",
description: "Mumbai to Imagica cab price offers transparent and affordable travel options for passengers planning trips to Imagica Theme Park. Clear pricing details help travelers understand the total journey cost before booking. Our fleet includes sedans, SUVs, and premium vehicles suited for different travel needs. Comfortable seating and AC interiors ensure relaxed travel conditions. Professional drivers ensure safe highway travel and punctual arrival. Pickup services are available across Mumbai including airport terminals. Flexible travel options allow passengers to choose one-way or round-trip journeys. Budget-friendly fares ensure convenient cab travel."
},
{
name: "Mumbai to Imagica Taxi Fare",
description: "Mumbai to Imagica taxi fare is calculated using transparent per-kilometer pricing to provide clear travel costs. Passengers can choose vehicles based on comfort and budget preferences. Our AC vehicles ensure smooth highway travel between Mumbai and Imagica park. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for family trips and tourism travel. Flexible booking options allow easy travel planning. Reliable fare structure ensures stress-free taxi booking."
},
{
name: "Mumbai to Imagica One Way Cab",
description: "Mumbai to Imagica one way cab service is ideal for travelers who require a drop service without paying return charges. This option helps reduce overall travel expenses while ensuring comfortable transportation. AC sedans and SUVs provide relaxed seating for highway journeys. Professional drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourists, families, and day trip travelers. Flexible departure timing allows convenient scheduling. Reliable one-way cab service ensures affordable travel."
},
{
name: "Mumbai to Imagica Round Trip Taxi",
description: "Mumbai to Imagica round trip taxi service offers complete travel convenience for passengers planning a return journey after visiting the theme park. Flexible return schedules allow travelers to enjoy rides and attractions without worrying about transportation. Comfortable AC vehicles ensure relaxed travel during the entire journey. Professional drivers remain available for return travel as per passenger timing. Pickup services are available across Mumbai including homes, hotels, and airport terminals. Ideal for family trips, corporate outings, and group visits. Spacious vehicles ensure comfortable travel for groups. Reliable round-trip taxi service ensures smooth travel planning."
}
],

tableData: [
["Mumbai to Imagica Cab","Mumbai to Imagica Taxi"],
["Mumbai to Imagica Cab Service","Mumbai to Imagica Taxi Service"],
["Cab from Mumbai to Imagica","Taxi from Mumbai to Imagica"],
["Mumbai to Imagica Cab Booking","Mumbai to Imagica Taxi Booking Online"],
["Mumbai to Imagica Cab Price","Mumbai to Imagica Taxi Fare"],
["Mumbai to Imagica One Way Cab","Mumbai to Imagica Round Trip Taxi"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Imagica Route Drivers",
    WhyChoosedescription: "Our drivers are well experienced with the Mumbai to Imagica route via the Mumbai–Pune Expressway. They understand the best travel timings, traffic conditions, and highway routes to ensure a safe and smooth journey to Imagica Theme Park."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Mumbai to Imagica cab bookings. We clearly explain per-kilometer fares, toll charges, and travel packages before confirming your booking so there are no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you want to start early morning for a full day at Imagica or return late at night, Omshree Cabs provides 24/7 cab booking and customer support for Mumbai to Imagica travel."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized to ensure a comfortable ride for families and groups visiting Imagica."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We provide flexible travel options including one-way cabs, round-trip bookings, and same-day return packages for Mumbai to Imagica trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for couples, families, and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and airports anywhere in Mumbai so your Imagica trip begins comfortably and without any travel stress."
  },
  {
    WhyChooseheading: "Reliable Theme Park Travel Service",
    WhyChoosedescription: "Omshree Cabs is trusted by travelers for Mumbai to Imagica cab services. Our punctual drivers, comfortable vehicles, and professional service ensure a fun and stress-free theme park journey."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Imagica by cab?", answer: "The distance from Mumbai to Imagica Theme Park is approximately 90 km and the journey usually takes around 2–3 hours depending on traffic." },
  { question: "Do you provide one-way Mumbai to Imagica cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services between Mumbai and Imagica." },
  { question: "Which vehicles are available for Mumbai to Imagica travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort preference." },
  { question: "Can we book a same-day return trip from Imagica?", answer: "Yes, many customers choose same-day return packages for Mumbai to Imagica travel." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide pickup from Mumbai Airport or any location in Mumbai for Imagica cab bookings." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey for food or rest?", answer: "Yes, passengers can request stops during the journey for meals or refreshments." },
  { question: "Is advance booking recommended for weekends?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and vacation seasons when Imagica receives many visitors." },
  { question: "Do you provide group travel options?", answer: "Yes, SUVs and larger vehicles are available for families and group trips visiting Imagica." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Jain",
    feedback:
      "We booked Omshree Cabs for our family trip from Mumbai to Imagica. The driver was punctual and the car was very comfortable. Perfect service for a theme park trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Shah",
    feedback:
      "Our Imagica trip from Mumbai with Omshree Cabs was fantastic. Smooth journey, clean car, and very professional driver.",
    rating: 5
  }
];





















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Imagica Cab",
  "description": "Book Mumbai to Imagica Cab with Omshree Cab for safe and comfortable travel to the theme park. Reliable taxi service from Mumbai to Imagica with one-way and round trip options. Affordable fares, easy online cab booking, and trusted service for your Imagica trip.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1800"
  }
};




  return (
    <div>
      


<Helmet>
  <title>Mumbai to Imagica Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Imagica Cab with Omshree Cab for comfortable travel. Taxi service from Mumbai to Imagica with one-way and round trip options. Affordable fares and easy online cab booking for your Imagica trip." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/30.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoimagicacab;